import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TRootState } from 'redux/store';
import { selectCurrentUser } from '../modules/auth/authSlice';
import { IUser } from '../modules/auth/services/type';

export const useAuth = (): { user: IUser | null; justLoggedIn: boolean } => {
  const user = useSelector(selectCurrentUser);
  const justLoggedIn = useSelector((state: TRootState) => state.auth.justLoggedIn);

  return useMemo(() => ({ user, justLoggedIn }), [user, justLoggedIn]);
};
